import { cn } from '@repo/ui/utils'

export function H3({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
  children: React.ReactNode
  className?: string
}) {
  return (
    <h3
      className={cn(
        'text-primary-600 select-none scroll-m-20 text-xl font-semibold tracking-tight',
        className,
      )}
      {...props}
    >
      {children}
    </h3>
  )
}
